module.exports = __webpack_public_path__ + "static/02-a0d18ba807981bddf855ff44c15a5263.png";